export default {
    client: null,
    clientLogged: false,
    email_register: null,
    list_employee_types: []
}
  